import isUndefined from 'lodash/isUndefined';

const MAGIC_URL_PARENT_PATH = '/customers';

export const API_URL_CONFIG = {
  DASHBOARD: {
    GET_DASHBOARD: '/dashboard',
    GET_VDI_TRANSACTION: '/reports/vdi-transactions',
    GET_QUIK_PICK: '/reports/quikpick-products',
    GET_SMART_COOLER_PRODUCT_COUNT: '/reports/cvproducts',
    GET_ALERT: '/reports/alerts',
  },
  PROVIDER: {
    CREATE_PROVIDER: '/providers',
    GET_ALL_PROVIDER: '/providers',
  },
  USER: {
    CREATE_USER: '/users',
    GET_ALL_USERS: '/users',
    GET_USER: '/users/:id',
    GET_ROLES: '/roles',
  },
  LOCATION: {
    CREATE_LOCATION: '/locations',
    GET_ALL_LOCATION: '/locations',
    GET_LOCATION: '/locations/:id',
    GET_LOCATIONS_LIST: '/locations/list',
  },
  MARKET: {
    GET_MARKET: '/markets',
    GET_DOWNLOAD_PDF_CSV: '/reports/markets/download',
    GET_MARKETS_LIST: '/markets/list',
  },
  SUBAPPLICATION: {
    GET_ALL_SUBAPPLICATIONS: '/subapplications',
  },
  QUICK_PAY_MASTER_PRODUCT: {
    GET_ALL_MASTER_PRODUCTS: '/subapplications/quikpick/approved-products',
    GET_DOWNLOAD_PDF_CSV: '/reports/quikpickproducts/download',
  },
  VDI_TRANSACTION: {
    GET_ALL_VDI_TRANSACTIONS: '/vditransactions',
    GET_VDI_TRANSACTION_BY_ID: '/vditransactions/:id',
  },
  OPERATOR: {
    GET_OPERATORS: '/operators',
    GET_OPERATORS_LIST: '/operators/list',
    CREATE_OPERATOR: '/operators',
  },
  PRODUCT: {
    GET_PRODUCT: '/products',
    GET_DOWNLOAD_PDF_CSV: '/reports/products/download',
  },
  RECONCILIATION: {
    GET_RECONCILIATION: 'reports/reconciliation',
    GET_DOWNLOAD_REPORT: 'reports/reconciliation/download',
  },
  ALERT: {
    GET_ALERTS: 'alerts',
  },
  DEVICE: {
    GET_DEVICE: '/devices',
    GET_DOWNLOAD_PDF_CSV: '/reports/devices/download',
    GET_DEVICES_LIST: '/devices/list',
  },

  MMS_SALES: {
    GET_MMS_SALES: '/orders',
    GET_DOWNLOAD_PDF_CSV: '/reports/orders/download',
  },
  CRON_JOBS_TRACKER: {
    GET_CRON_JOBS_TRACKER: '/cronjobs/tracker',
  },
  SMART_COOLER_PRODUCTS: {
    GET_DOWNLOAD_PDF_CSV: '/reports/cvproducts/download',
  },
  COOLER_TRANSACTION: {
    GET_ALL_TRANSACTIONS: '/smartcoolers/transactions',
  },
  MAGIC_URL: {
    SMARTCOOLER_APPROVED_PRODUCTS: `${MAGIC_URL_PARENT_PATH}/smartcoolerproducts`,
  },
};

export const VDI_SETTINGS = {
  SERVER: {
    '1': {
      BASE_URL:
        import.meta.env.VITE_VDI_V1_BASE_URL || 'https://api-qa.yokeinc.com',
      BASE_VERSION: !isUndefined(import.meta.env.VITE_VDI_V1_BASE_VERSION)
        ? import.meta.env.VITE_VDI_V1_BASE_VERSION
        : 'v2',
      BASE_PATH: !isUndefined(import.meta.env.VITE_VDI_V1_BASE_PATH)
        ? import.meta.env.VITE_VDI_V1_BASE_PATH
        : 'vdi',
      PATH_VERSION: !isUndefined(import.meta.env.VITE_VDI_V1_PATH_VERSION)
        ? import.meta.env.VITE_VDI_V1_PATH_VERSION
        : 'v1',
    },
    '2': {
      BASE_URL:
        import.meta.env.VITE_VDI_V2_BASE_URL || 'https://api-qa.yokeinc.com',
      BASE_VERSION: !isUndefined(import.meta.env.VITE_VDI_V2_BASE_VERSION)
        ? import.meta.env.VITE_VDI_V2_BASE_VERSION
        : 'v2',
      BASE_PATH: !isUndefined(import.meta.env.VITE_VDI_V2_BASE_PATH)
        ? import.meta.env.VITE_VDI_V2_BASE_PATH
        : 'vdi',
      PATH_VERSION: !isUndefined(import.meta.env.VITE_VDI_V2_PATH_VERSION)
        ? import.meta.env.VITE_VDI_V2_PATH_VERSION
        : '', // Path version is empty for v2 — configured via VITE_VDI_V2_PATH_VERSION env var
    },
  },
};
